/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Fragment } from 'react';

import { Typography2 } from '@coursera/cds-core';
import { track } from '@coursera/event-pulse/sdk';

import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  divider: css`
    margin-top: var(--cds-spacing-100);
  `,
  notSureWhereToBegin: css`
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    padding: var(--cds-spacing-150) var(--cds-spacing-100) var(--cds-spacing-50);
    margin-top: var(--cds-spacing-100);
  `,
};

const BrowseFreeCoursesMenuItem = () => {
  return (
    <Fragment>
      <Typography2 component="p" variant="bodyPrimary" color="supportText" css={styles.notSureWhereToBegin}>
        {_t('Not sure where to begin?')}
      </Typography2>
      <MobileButton
        label={_t('Browse free courses')}
        href="/courses?query=free"
        name="browseFreeCourses"
        trackingName="browse_free_courses"
        onButtonClick={() => {
          track('click_megamenu_item', {
            megamenuItemLink: '/courses?query=free',
            megamenuItemName: 'browse-free-courses',
            megamenuSection: 'mobile',
            megamenuItemType: 'other',
          });
        }}
      />
    </Fragment>
  );
};

export default BrowseFreeCoursesMenuItem;
